export function setupDeliveryDates() {
    const deliveryDates = document.querySelector('.delivery-dates');

    if (deliveryDates) {
        const deliveryDatesSearchField = deliveryDates.querySelector('.delivery-dates__zip');
        const deliveryDatesSearchResultText = deliveryDates.querySelector('.delivery-dates__search-result-text');
        const deliveryDatesZipPlaceholder = deliveryDates.querySelector('.delivery-dates__zip-placeholder');
        const deliveryDatesDaysPlaceholder = deliveryDates.querySelector('.delivery-dates__days-placeholder');
        const deliveryDatesErrorMessagePlaceholder = deliveryDates.querySelector('.delivery-dates__error-message-placeholder');
        const errorMessage = deliveryDates.getAttribute('data-error-message');

        function showSearchResultText() {
            deliveryDatesSearchResultText.classList.add('js-show');
        }

        function hideSearchResultText() {
            deliveryDatesSearchResultText.classList.remove('js-show');
        }

        function showErrorMessage() {
            deliveryDatesErrorMessagePlaceholder.textContent = errorMessage;
        }

        function hideErrorMessage() {
            deliveryDatesErrorMessagePlaceholder.textContent = '';
        }

        function searchZipCode(zipCode) {
            const jsonUrl = `${window.location.protocol}//${window.location.hostname}/Files/Templates/Designs/keflico/deliverydates.json`;
            const request = new XMLHttpRequest();

            request.open('GET', jsonUrl, true);

            request.onload = function () {
                if (request.status >= 200 && request.status < 400) {
                    const data = JSON.parse(request.responseText);
                    const searchData = data.deliveryZipCodes.filter(x => x.zipCode == zipCode);

                    if (searchData.length == 1) {
                        const areaId = searchData[0].areaId;
                        const areaData = data.deliveryAreas.filter(x => x.id == areaId);
                        const weekdays = data.weekdays;

                        if (areaData.length == 1) {
                            const areaDays = areaData[0].days;

                            deliveryDatesZipPlaceholder.textContent = zipCode;

                            if (areaDays != '0,1,2,3,4') {
                                const daysArray = areaDays.split(',');
                                let daysText = '';

                                daysArray.forEach((day,index) => {
                                    if (index + 1 < daysArray.length) {
                                        if (daysText.length > 0) {
                                            daysText += `, ${weekdays[day]}`;
                                        } else {
                                            daysText = weekdays[day];
                                        }
                                    } else {
                                        if (daysText.length > 0) {
                                            daysText += ` og ${weekdays[day]}`;
                                        } else {
                                            daysText = weekdays[day];
                                        }
                                    }
                                });

                                showSearchResultText();
                                deliveryDatesDaysPlaceholder.textContent = daysText;
                            } else {
                                showSearchResultText();
                                deliveryDatesDaysPlaceholder.textContent = 'Alle hverdage';
                            }

                            hideErrorMessage();
                        } else {
                            hideSearchResultText();
                            showErrorMessage();
                        }
                    } else {
                        hideSearchResultText();
                        showErrorMessage();
                    }
                }
            };

            request.onerror = function () {

            };

            request.send();
        }

        function searchDates(e) {
            const searchValue = e.currentTarget.value.trim();

            if (searchValue.length == 4) {
                searchZipCode(searchValue);
            } else {
                deliveryDatesDaysPlaceholder.textContent = '';
                hideSearchResultText();
                hideErrorMessage();
            }
        }

        if (
            deliveryDatesSearchField &&
            deliveryDatesSearchResultText &&
            deliveryDatesZipPlaceholder &&
            deliveryDatesDaysPlaceholder &&
            deliveryDatesErrorMessagePlaceholder
        ) {
            deliveryDatesSearchField.addEventListener('keyup',searchDates);
        }
    }
}